export interface BookPageStates {
  activeJobCode: string;
  loading: boolean;
}

export const initialBookPageStates: BookPageStates = {
  activeJobCode: null,
  loading: false,
};
